import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteUser } from "../openapi/api-client.ts";

export const useDeleteUser = (projectId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (username: string) => {
      return deleteUser({
        path: { projectId, username },
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["users", { projectId }],
        }),
        queryClient.invalidateQueries({
          queryKey: ["directoryProtections", { projectId }],
        }),
      ]);
    },
  });
};
